import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { TemplateReportViewStore } from "../stores";
import { TemplateReportTemplate } from "themes/application/template-report/pages";

@setCurrentView(rootStore => new TemplateReportViewStore(rootStore), "templateReportViewStore")
@observer
class TemplateReport extends React.Component {
    render() {
        return <TemplateReportTemplate {...this.props} />;
    }
}

export default TemplateReport;